module.exports = __webpack_public_path__ + "img/05_new2017_pr_s.7187e405.png";